import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

type StyleModalData = {
    isEdit: boolean;
    name: string;
    styleName: string;
    workspace: string;
    geometryType?: string;
}

export const initialStyleModalData: StyleModalData = {
    isEdit: false,
    name: "",
    styleName: "",
    workspace: "",
    geometryType: undefined,
}


type InitialStyleState = {
    currentWorkspace: string | null;
    showStyleModal: boolean;
    styleModalData: StyleModalData
}

const initialState: InitialStyleState = {
    currentWorkspace: null,
    showStyleModal: false,
    styleModalData: initialStyleModalData
}

export const styleSlice = createSlice({
    name: 'style',
    initialState,
    reducers: {
        setCurrentWorkspace: (state, action: PayloadAction<string | null>) => {
            state.currentWorkspace = action.payload;
        },
        setShowStyleModal: (state, action: PayloadAction<boolean>) => {
            state.showStyleModal = action.payload;
        },
        setStyleModalData: (state, action: PayloadAction<StyleModalData>) => {
            state.styleModalData = action.payload;
        }
    },
})

export const { setCurrentWorkspace, setShowStyleModal, setStyleModalData } = styleSlice.actions

export default styleSlice.reducer

